import { useElementRect } from "@/composables/useElementRect";
import pixelToRem from "@/helpers/shared/pixelToRem";
import { useWindowSize } from "@vueuse/core";
import { computed, type Ref, type CSSProperties } from "vue";

export function useContentHeight(containerRef: Ref<Element | null>) {
  const containerRect = useElementRect(containerRef);
  const { height } = useWindowSize();

  const dynamicHeight = computed(() => {
    return Math.floor(height.value - (containerRect.value?.top || 0));
  });

  const dynamicStyles = computed<CSSProperties>(() => {
    return {
      height: pixelToRem(dynamicHeight.value),
    };
  });

  return {
    dynamicHeight,
    dynamicStyles,
  };
}
